import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HaishaHoho = props => {
  return <Dropdown.Static kubunKey='haisha_hoho' {...props} />
}
